export default {
  musicalGenres: 'संगीत शैलियों',
  seeMore: 'अधिक देखें',
  artists: 'कलाकारों',
  songs: 'गाने',
  topMusicalGenres: 'शीर्ष संगीत शैलियों',
  additionalGenres: 'अतिरिक्त शैलियों',
  topArtists: 'शीर्ष कलाकार',
  additionalArtists: 'अतिरिक्त कलाकार',
  topSongs: 'शीर्ष गाने',
  additionalSongs: 'अतिरिक्त गाने',
  likes: 'पसंद',
  peopleLikes: 'लोगों को पसंद है',
  additionalLikes: 'अतिरिक्त पसंद',
  peoplePerJourneyStatus: 'लोग प्रति यात्रा की स्थिति'
}
